import { render, staticRenderFns } from "./tai-xiu-board-header.vue?vue&type=template&id=1f62ce9a&scoped=true"
import script from "./tai-xiu-board-header.vue?vue&type=script&lang=js"
export * from "./tai-xiu-board-header.vue?vue&type=script&lang=js"
import style0 from "./tai-xiu-board-header.vue?vue&type=style&index=0&id=1f62ce9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f62ce9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f62ce9a')) {
      api.createRecord('1f62ce9a', component.options)
    } else {
      api.reload('1f62ce9a', component.options)
    }
    module.hot.accept("./tai-xiu-board-header.vue?vue&type=template&id=1f62ce9a&scoped=true", function () {
      api.rerender('1f62ce9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/tai-xiu-board-header.vue"
export default component.exports